<template>
  <a-modal v-model="visible" :title="`${form.id ? $t('编辑菜单信息') : $t('新增菜单信息')}`" :width="1000" destroyOnClose>
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('所属应用')" prop="appId">
            <a-select v-model="form.appId" :options="appOptions" :disabled="form.id != null" allowClear @change="handleChangeApp" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('上级菜单')" prop="parentId">
            <a-tree-select v-model="form.parentId" :treeData="menuTree" :replaceFields="{ title: 'name', key: 'id', value: 'id' }" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('菜单类型')" prop="type">
            <a-select v-model="form.type" :options="MenuTypeOptions" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('菜单名称')" prop="name">
            <a-input v-model="form.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.appId == null">
          <a-form-model-item :label="$t('菜单标识')" prop="key">
            <a-input v-model="form.key" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.appId == null">
          <a-form-model-item :label="$t('组件')" prop="component">
            <a-input v-model="form.component" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.appId == null">
          <a-form-model-item :label="$t('访问地址')" prop="path">
            <a-input v-model="form.path" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.appId != null">
          <a-form-model-item :label="$t('绑定页面')" prop="pageId">
            <a-tree-select v-model="form.pageId" :treeData="pageTree" :replaceFields="{ title: 'name', value: 'key' }" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('权限字符')" prop="permission">
            <a-input v-model="form.permission" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('验证方式')" prop="authType">
            <a-select v-model="form.authType" :options="menuAuthTypeOptions" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('顺序号')" prop="sortNum">
            <a-input-number :min="0" :precision="0" v-model="form.sortNum" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { getMenuTree, saveMenu } from '@/api/system/menu'
import { MenuTypeOptions, menuAuthTypeOptions } from '@/constants/SystemConstatns'
import { getAppListForCurrentUser } from '@/api/app/app'
import { getFolderList } from '@/api/app/folder'

export default {
  data() {
    return {
      MenuTypeOptions,
      menuAuthTypeOptions,
      appOptions: [],
      visible: false,
      menuTree: [],
      form: {},
      loading: false,
      pageTree: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rules() {
      const result = {
        name: [{ required: true, message: this.$t('请输入') }],
        key: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.loadOptions()
      this.visible = true
    },
    loadOptions() {
      getMenuTree({ appId: this.form.appId }).then(res => {
        const menuTree = res.data || []
        this.menuTree = [{ name: this.$t('无'), id: null }].concat(menuTree)
      })
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
      if (this.form.appId != null) {
        getFolderList({appId: this.form.appId}).then(res => {
          const list = res.data || []
          const buildTree = (folders, parentId) => {
            const roots = folders.filter(e => (parentId == null && (e.parentId == null || e.parentId == '0')) || (parentId != null && e.parentId == parentId)).map(e => ({
              key: e.id,
              name: e.name,
              menuType: 'folder',
              pages: e.pages,
              selectable: false,
            }))
            roots.forEach(e => {
              let children = buildTree(folders, e.key) || []
              if (e.pages && e.pages.length > 0) {
                children = children.concat(e.pages.map(p => ({ key: p.id, name: p.name, selectable: true })))
              }
              e.children = children
            })
            return roots
          }
          this.pageTree = buildTree(list, null)
        })
      }
    },
    handleChangeApp(appId) {
      this.loadOptions()
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          ...this.form,
        }
        saveMenu(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>